module.exports = __webpack_public_path__ + "img/default.afbb64e7.png";